
































































import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'

export default Vue.extend({
  // computed: {
  //   activeTab: {
  //     get (): string {
  //       return this.$route.name!
  //     },
  //     set () {

  //     }
  //   }
  // },
  data() {
    return {
      activeTab: this.$route.name || 'newslettersReadyListStuff'
    }
  },
  watch: {
    $route (to, from) {
      const routeName = this.$route.name;

      if (routeName === 'newslettersReadyListStuffPage') {
        this.activeTab = 'newslettersReadyListStuff'
      } else if (routeName === 'newslettersInProgressListStuffPage') {
        this.activeTab = 'newslettersInProgressListStuff'
      } else if (routeName === 'newslettersComplitedListStuffPage') {
        this.activeTab = 'newslettersComplitedListStuff'
      } else if (routeName === 'newslettersCanceledListStuffPage') {
        this.activeTab = 'newslettersCanceledListStuff'
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
